/* =========================================================
   PRIME CUTS — Cart enhancements
   The bundle app writes the box contents as one plain string with no
   handles or ids, e.g. "1x  (2) 1 lb. Stew Meat , 2x  (2) 14oz Thighs".
   Photos and categories come from matching those titles against the
   cuts collection, rendered into the page as JSON.
   ========================================================= */

(function () {
  var MAP_ID = 'pc-bundle-cuts';

  /* Lowercase, drop a leading "(2)", strip punctuation, collapse spaces.
     Loose enough to survive small title edits in admin. */
  function normalise(title) {
    return String(title || '')
      .toLowerCase()
      .replace(/^\s*\(\d+\)\s*/, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  var lookup = null;

  function buildLookup() {
    if (lookup) return lookup;
    lookup = {};
    var node = document.getElementById(MAP_ID);
    if (!node) return lookup;
    try {
      JSON.parse(node.textContent).forEach(function (entry) {
        var key = normalise(entry.t);
        if (key && !lookup[key]) lookup[key] = entry;
      });
    } catch (e) {
      console.error('[PCCart] cuts map', e);
    }
    return lookup;
  }

  /* "1x  (2) 1 lb. Stew Meat" -> { qty: 1, title: '1 lb. Stew Meat' } */
  function parseEntry(raw) {
    var text = String(raw).replace(/\s+/g, ' ').trim();
    if (!text) return null;

    var qty = 1;
    var match = text.match(/^(\d+)\s*x\s*/i);
    if (match) {
      qty = parseInt(match[1], 10) || 1;
      text = text.slice(match[0].length);
    }

    /* The leading count is packaging detail, not a quantity. */
    text = text.replace(/^\(\d+\)\s*/, '').trim();
    if (!text) return null;

    return { qty: qty, title: text };
  }

  /* Split a leading weight off the title: "12-16 oz Chicken Wings"
     becomes spec "12-16 oz" and name "Chicken Wings". */
  var WEIGHT = /^([\d.\/-]+\s*(?:lbs?|oz)\b\.?(?:\s*[-\u2013]\s*[\d.]+\s*(?:lbs?|oz)\b\.?)?)\s*/i;

  function splitTitle(title) {
    var match = title.match(WEIGHT);
    if (!match) return { name: title, spec: '' };
    var rest = title.slice(match[0].length).trim();
    if (!rest) return { name: title, spec: '' };
    return { name: rest, spec: match[1].trim() };
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function tileHTML(entry, found) {
    var parts = splitTitle(entry.title);
    /* A real <img> rather than an inline background-image: the URL would
       otherwise have to be quoted inside a quoted style attribute. */
    var photo = found && found.i
      ? '<img src="' + escapeHTML(found.i) + '" alt="" loading="lazy" width="200" height="200">'
      : '';
    var badge = entry.qty > 1
      ? '<span class="pc-cut-tile-qty-badge">' + entry.qty + '\u00d7</span>'
      : '';
    return '<div class="pc-cut-tile">' +
      '<div class="pc-cut-tile-photo">' + photo + badge + '</div>' +
      '<div class="pc-cut-tile-info">' +
        '<h4>' + escapeHTML(parts.name) + '</h4>' +
        (parts.spec ? '<div class="spec">' + escapeHTML(parts.spec) + '</div>' : '') +
      '</div></div>';
  }

  function render(container) {
    var raw = container.dataset.pcRaw;
    if (!raw) return;

    var entries = raw.split(',').map(parseEntry).filter(Boolean);
    if (!entries.length) return;

    var cuts = buildLookup();
    var other = container.dataset.pcCatOther || 'More';
    var order = (container.dataset.pcCatOrder || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    /* Group by the matched product's type; unmatched cuts fall through
       to the fallback bucket rather than disappearing. */
    var groups = {};
    var total = 0;
    entries.forEach(function (entry) {
      var found = cuts[normalise(entry.title)];
      var category = (found && found.c) ? found.c : other;
      (groups[category] = groups[category] || []).push({ entry: entry, found: found });
      total += entry.qty;
    });

    var names = Object.keys(groups).sort(function (a, b) {
      var ai = order.indexOf(a), bi = order.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });

    container.innerHTML = names.map(function (name) {
      var rows = groups[name];
      var count = rows.reduce(function (n, r) { return n + r.entry.qty; }, 0);
      return '<div class="pc-cat-group">' +
        '<div class="pc-cat-group-head">' +
          '<h3>' + escapeHTML(name) + '</h3>' +
          '<span class="cnt">' + count + (count === 1 ? ' cut' : ' cuts') + '</span>' +
        '</div>' +
        '<div class="pc-cut-grid">' +
          rows.map(function (r) { return tileHTML(r.entry, r.found); }).join('') +
        '</div></div>';
    }).join('');

    container.classList.add('is-ready');
    updateStatus(container, total);
  }

  function updateStatus(container, total) {
    var card = container.closest('.pc-box-card');
    if (!card) return;
    var status = card.querySelector('[data-pc-status]');
    if (!status) return;

    var cap = parseInt(status.dataset.pcCap, 10) || 0;
    var countEl = status.querySelector('[data-pc-count]');
    if (countEl) {
      countEl.innerHTML = cap > 0
        ? total + '<span class="of"> / ' + cap + '</span>'
        : String(total);
    }

    var bar = status.querySelector('[data-pc-progress] .fill');
    if (bar && cap > 0) {
      var pct = Math.min(100, Math.round((total / cap) * 100));
      bar.style.width = pct + '%';
      status.querySelector('[data-pc-progress]').classList.toggle('full', total >= cap);
    }
  }

  function renderAll() {
    document.querySelectorAll('[data-pc-box-contents]').forEach(function (el) {
      if (el.classList.contains('is-ready')) return;
      try { render(el); } catch (e) { console.error('[PCCart] box contents', e); }
    });
  }

  function start() {
    renderAll();

    /* Dawn replaces the whole .js-contents subtree through the Section
       Rendering API on every cart change, wiping what we drew. Watching
       the container re-renders without depending on Dawn's events. */
    var host = document.querySelector('#main-cart-items .js-contents');
    if (!host) return;
    new MutationObserver(renderAll).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
